module.exports = __webpack_public_path__ + "img/tour2-crop.06795234.jpg";